(ns frontend.view.grid.funds-grid.columns
  (:require [frontend.state.current-session :as session]))

;;default set of selected columns
(def ordered-default-columns
  [:fund/name
   :fund/status
   :fund/cur-fund-size
   :fund/first-closing-date
   :fund/vintage-year
   :fund/cur-total-committed-capital
   :fund/cur-total-called-capital])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:fund/name})
